import React from 'react';
import { CheckIcon, ZapIcon, DownloadIcon, InfinityIcon, CreditCardIcon, ShoppingCartIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
export function PricingSection() {
  const packageItems = ['5 Tomos Crianza Montessori en Casa', 'Workbook imprimible', 'Bono 1 (GRATIS HOY)', 'Bono 2 (GRATIS HOY)', 'Bono 3 (GRATIS HOY)'];
  const benefits = [{
    icon: ZapIcon,
    text: 'Acceso inmediato'
  }, {
    icon: CreditCardIcon,
    text: 'Un solo pago'
  }, {
    icon: DownloadIcon,
    text: 'Descarga digital'
  }, {
    icon: InfinityIcon,
    text: 'Acceso de por vida'
  }, {
    icon: ShoppingCartIcon,
    text: 'Compra por Mercado Pago'
  }];
  return <section id="compra" className="w-full bg-[#FDF8F3] py-16 px-4 scroll-mt-20" data-id="element-183">
      <div className="max-w-3xl mx-auto" data-id="element-184">
        {/* Urgency Header */}
        <div className="text-center mb-10" data-id="element-185">
          <span className="inline-block bg-[#FDF0EB] text-[#C4645A] text-sm font-bold px-4 py-2 rounded-full mb-4 animate-pulse" data-id="element-186">
            ⏰ Oferta por tiempo limitado
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033]" data-id="element-187">
            📦 Todo lo que recibís hoy
          </h2>
          <p className="text-xl text-[#8B9E7E] font-semibold mt-2" data-id="element-188">
            + los 3 Bonos de regalo
          </p>
        </div>

        {/* Pricing Card */}
        <div className="bg-gradient-to-b from-[#F5EDE4] to-[#FDF8F3] rounded-3xl shadow-2xl border border-[#E0D5C8] overflow-hidden" data-id="element-189">
          <div className="p-8 sm:p-10" data-id="element-190">
            <ul className="space-y-3 mb-8" data-id="element-191">
              {packageItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-192">
                  <span className="flex-shrink-0 w-5 h-5 bg-[#8B9E7E] text-white rounded-full flex items-center justify-center mt-0.5" data-id="element-193">
                    <CheckIcon className="w-3 h-3" data-id="element-194" />
                  </span>
                  <span className="text-[#8B7355]" data-id="element-195">{item}</span>
                </li>)}
            </ul>

            {/* Price Display */}
            <div className="text-center py-6 border-t border-b border-[#E0D5C8]" data-id="element-196">
              <p className="text-[#8B7355] mb-2" data-id="element-197">
                Si compraras cada recurso por separado, superarías los{' '}
                <span className="font-semibold" data-id="element-198">$49.990 ARS</span>.
              </p>
              <p className="text-[#8B7355] mb-4" data-id="element-199">
                💰 Valor total real:{' '}
                <span className="line-through text-[#C4645A] font-semibold" data-id="element-200">
                  $49.990 ARS
                </span>
              </p>
              <p className="text-lg text-[#5C4033] mb-2 font-semibold" data-id="element-201">
                🔥 HOY ACCEDÉS POR SOLO:
              </p>
              <p className="text-5xl sm:text-6xl font-bold text-[#8B9E7E]" data-id="element-202">
                $19.990 ARS
              </p>
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-2 gap-4 my-8" data-id="element-203">
              {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-2 text-[#8B7355]" data-id="element-204">
                  <benefit.icon className="w-5 h-5 text-[#8B9E7E]" data-id="element-205" />
                  <span className="text-sm" data-id="element-206">✔ {benefit.text}</span>
                </div>)}
            </div>

            {/* CTA Button */}
            <a href={CHECKOUT_URL} className="block w-full bg-[#8B9E7E] hover:bg-[#6B8068] text-white text-xl font-bold py-5 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105 text-center" data-id="element-207">
              👉 QUIERO CRIAR CON MÁS CALMA DESDE HOY
            </a>
          </div>
        </div>
      </div>
    </section>;
}